import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { resolveBreadcrumbItems } from "config/breadcrumbRoutes";
import * as S from "./style";

function Breadcrumb() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const items = resolveBreadcrumbItems(pathname, t);

  if (items.length === 0) {
    return null;
  }

  return (
    <S.Wrapper aria-label="현재 위치">
      <S.List>
        {items.map((item, index) => (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 && <S.Separator aria-hidden="true">&gt;</S.Separator>}
            <S.Item $current={item.isCurrent}>{item.label}</S.Item>
          </React.Fragment>
        ))}
      </S.List>
    </S.Wrapper>
  );
}

export default Breadcrumb;
